<template>
    <div class="container">
        <ContentOrLoading>
            <b-row v-if="zona_detalle">
                <LayoutSelectSeats
                    :zona="zona_detalle"
                    @volver="$emit('volver')"
                >
                    <template v-slot:asientos-seleccionados>
                        <TusAsientosSGA
                            :loading="loading"
                            :asientos="asientos_seleccionados"
                            @continuar="continuar"
                        />
                    </template>
                    <template v-slot:seat-map>
                        <SeatMapSga
                            :loading="loading"
                            :print_align="zona_detalle.print_align"
                            :filas="zona_detalle.configuracion"
                            @asientoSeleccionado="selectSeat"
                        />
                    </template>
                </LayoutSelectSeats>
                <button type="button" name="button" class="button effect-button mr-4 mt-4 ml-auto" :class="{ 'large-button': !esMovil }" @click="$emit('volver')">
                    <span>{{ $t('formularios.atras') }}</span>
                </button>

            </b-row>
        </ContentOrLoading>
    </div>
</template>

<script>
    import SeatMapSga from '../../../common/Asientos/SeatMapSga.vue';
    import LayoutSelectSeats from '../../../common/Asientos/LayoutSelectSeats.vue';
    import TusAsientosSGA from './components/TusAsientosSGA.vue';

    export default {
        props: {
            zona: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                zona_detalle: null,
                max_seats: 8,
                asientos_seleccionados: [],
                loading: false
            }
        },
        created() {
            this.loadZona(this.zona.id);
        },
        methods: {
            loadZona(id) {
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('sga.abonados.zonas.asientos'), { zona_id: id }).then(res => {
                    this.zona_detalle = res.data.data;
                }).finally(() => this.loading = false);
            },
            selectSeat(asiento) {
                asiento.zona_nombre = this.zona_detalle.name;
                asiento.precios = this.zona_detalle.precios;
                
                Object.values(this.zona_detalle.configuracion).forEach(fila => {
                    Object.values(fila.asientos).forEach(a => {
                        if (a.seat_id === asiento.seat_id) {
                            if(a.seleccionado) {
                                a.seleccionado = false;
                            } else {
                                if (this.asientos_seleccionados.length < this.max_seats && !asiento.ocupado) {
                                    a.seleccionado = true;
                                }
                            }
                        }
                    });
                });

                if(this.asientos_seleccionados.find(a => a.seat_id === asiento.seat_id)) {
                    this.asientos_seleccionados = this.asientos_seleccionados.filter(a => a.seat_id !== asiento.seat_id);
                } else {
                    if(this.asientos_seleccionados.length < this.max_seats && !asiento.ocupado) {
                        this.asientos_seleccionados.push(asiento);
                    } else {
                        this.$toast.error('No puedes seleccionar más de ' + this.max_seats + ' asientos');
                    }
                }
            },
            continuar() {
                this.loading = true;

                let data = {
                    'salesChannelId': this.zona_detalle.configuration.salesChannels[0].salesChannelId,
                    'cartItem': {
                        "productId": this.lista.sga_product_id,
                        "seats": []
                    }
                }

                this.asientos_seleccionados.forEach(asiento => {
                    data.cartItem.seats.push({
                        'id': asiento.seat_id,
                        'row': asiento.fila,
                        'seat': asiento.asiento,
                        'salesCategoryId': asiento.precio_seleccionado.salesCategoryId,
                        'precio_id': asiento.precio_seleccionado.id,
                        'zoneId': asiento.precio_seleccionado.zoneId
                    })
                })

                this.$store.dispatch(this.config.getVuexAlias('sga.cart.create'), data).then(res => {
                    localStorage.setItem('sga_abono_cart_id', res.data.cart_id);
                    this.$emit('sesionCreada', res.data.items);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            SeatMapSga, LayoutSelectSeats, TusAsientosSGA
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            },
            lista() {
                return this.$store.getters.getListaAbonados;
            }
        }
    }
</script>